if(!customElements.get('block-video')){
    class BlockVideo extends HTMLElement {
        constructor(){
            super();

            this.videos = this.querySelectorAll('video');
        }

        connectedCallback(){
            this.videoType = this.dataset.videoType;
            this.template = this.querySelector('template')?.content.cloneNode(true);
            this.buttonPlay = this.querySelector('.button-play');
            this.autoplay = this.dataset.autoplay === 'true';
            
            if(this.template){
                this.querySelector('.custom-video-container')?.appendChild(this.template);
            }

            if(this.videoType === 'shopify'){
                this.initializeShopifyVideo();
            }else{
                this.initializeEmbedVideo();
            }

            this.initializeButtonCursor();

            if(this.buttonPlay){
                this.buttonPlay.addEventListener('focus', e => {
                    this.buttonPlay.classList.add('focused');
                    this.buttonPlay.addEventListener('blur', e => {
                        this.buttonPlay.classList.remove('focused');
                    }, { once: true });
                });
            }
        }

        initializeButtonCursor(){
            const isDesktop = window.matchMedia('(min-width: 64em)').matches;
            if (!this.buttonPlay || !isDesktop) return;

            this.buttonPlay.style.position = 'absolute';
            this.buttonPlay.style.zIndex = 20;
            this.buttonPlay?.querySelector('svg')?.classList.add('animate-in');

            let mouseX = 0, mouseY = 0;
            let currentX = 0, currentY = 0;
            const speed = 0.15;
            const padding = 20; 

            const container = this;

            container.addEventListener('mouseenter', (e) => {
                this.buttonPlay.style.transitionDuration = '0.3s';
                this.buttonPlay.classList.remove('opacity-0');
                this.buttonPlay.style.transitionDuration = '0.05s';
                this.buttonPlay.classList.remove('lg:hidden');
            });

            container.addEventListener('mouseleave', (e) => {
                this.buttonPlay.style.transitionDuration = '0.3s';
                this.buttonPlay.classList.add('opacity-0');
                this.buttonPlay.style.transitionDuration = '0.05s';
            });

            container.addEventListener('mousemove', (e) => {
                if(this.buttonPlay.classList.contains('lg:hidden')){
                    this.buttonPlay.style.transitionDuration = '0.3s';
                    this.buttonPlay.classList.remove('opacity-0');
                    this.buttonPlay.style.transitionDuration = '0.05s';
                    this.buttonPlay.classList.remove('lg:hidden');
                }

                const rect = container.getBoundingClientRect();
                const offsetX = e.clientX - rect.left;
                const offsetY = e.clientY - rect.top;

                mouseX = Math.max(padding, Math.min(offsetX, rect.width - padding));
                mouseY = Math.max(padding, Math.min(offsetY, rect.height - padding));
            });

            const animate = () => {
                const buttonRect = this.buttonPlay.getBoundingClientRect();
                const halfWidth = buttonRect.width / 2;
                const halfHeight = buttonRect.height / 2;

                currentX += (mouseX - currentX) * speed;
                currentY += (mouseY - currentY) * speed;

                this.buttonPlay.style.left = `${currentX - halfWidth}px`;
                this.buttonPlay.style.top = `${currentY - halfHeight}px`;
                this.buttonPlay.style.transform = `translate(0, 0)`; // remove -50% shift
                
                requestAnimationFrame(animate);
            };

            animate();
        }

        initializeEmbedVideo(){
            this.iframe = this.querySelector('iframe');
            if(!this.iframe) return;

            if(this.autoplay){
                this.playIframe();
            }else{
                this.buttonPlay.addEventListener("click", this.playIframe.bind(this));
                this.buttonPlay.addEventListener("keydown", e => {
                    if(e.key === 'Enter') this.playIframe();
                });
            }
        }

        initializeShopifyVideo(){
            this.video = this.querySelector('video');
            if(!this.video) return;

            if(this.autoplay){
                this.playVideo();
            }else{
                this.buttonPlay.addEventListener("click", this.playVideo.bind(this));
                this.buttonPlay.addEventListener("keydown", e => {
                    if(e.key === 'Enter') this.playVideo();
                });
            }
        }

        playIframe(){
            if(!this.iframe) return;

            this.buttonPlay.setAttribute('inert', '');
            this.buttonPlay.classList.add('hidden');
            if(this.querySelector('.custom-video-player')){
                this.querySelector('.custom-video-player').removeAttribute('inert');
            }

            this.playing = true;
            const videoSrc = this.iframe.dataset.src;
            if(videoSrc){
                const paramExist = videoSrc.includes('?');
                this.iframe.setAttribute('src', `${videoSrc}${paramExist? '&' : '?'}autoplay=1&amp;modestbranding=1&amp;showinfo=0&amp;rel=0`);
                this.iframe.classList.add('loaded');
            }
        }

        playVideo(){
            if(!this.video) return;

            this.buttonPlay.setAttribute('inert', '');
            this.buttonPlay.classList.add('hidden');

            if(this.querySelector('.custom-video-player')){
                this.querySelector('.custom-video-player').removeAttribute('inert');
            }

            this.playing = true;
            this.video.classList.add('loaded');
            this.video.play();
        }
    }

    customElements.define('block-video', BlockVideo);
}